<template>
 <el-dialog title="配置门店" :before-close="onClose" :visible.sync="show" width="850px" append-to-body top="8vh">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名">
            <el-input disabled v-model="ruleForm.healthManagerName"></el-input>
          </el-form-item>
          <!--  -->
          <el-form-item :rules="[{required: true, message: '请选择门店', trigger: 'change'}]" label="门店列表"  prop="storeIds">
            <!-- <el-select @change="handleChange" v-model="ruleForm.storeId" placeholder="请选择门店">
              <el-option v-for="item in StoreConfigList" :key="item.id" :label="item.storeName" :value="item.id"></el-option>
            </el-select> -->
             <el-transfer
                style="text-align: left; display: inline-block"
                v-model="ruleForm.storeIds"
                filterable
                :right-default-checked="leftDefaultChecked"
                :titles="['门店列表', '已选择门店']"
                :button-texts="['到左边', '到右边']"
                :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                :props="{
                  key: 'id',
                  label: 'storeName'
                }"
                :render-content="renderFunc"
                @change="handleChange"
                :data="StoreConfigList">
                <span slot-scope="{ option }">{{ option.id }} - {{ option.storeName }}</span>
              </el-transfer>
          </el-form-item>
          <el-form-item class="btn_flex">
            <el-button type="primary" v-debounce="submitForm">立即配置</el-button>
            <el-button @click="resetForm2('ruleForm')">重置</el-button>
          </el-form-item>
    </el-form>
  </el-dialog>
  
</template>

<script>
import {healthManagerStoreConfigList, healthManagerStoreBatchSave} from '@/api/system/doctorManage'
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    },
    show: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    show: {
      handler(val) {
      // console.log('show====>', this.show);
      if(val) {
        this.handleConfiguration(this.detail)
      }else {
        this.leftDefaultChecked = []
      }
      },
      immediate: true
    }
  },
  data() {
    return {
      leftDefaultChecked: [],
       ruleForm: {
        storeIds: [],
        healthManagerName: ''
      },
      rules: {
      //   storeIds: [{required: true, message: '请选择门店', trigger: 'change'}]
      },
      StoreConfigList: [],
      renderFunc(h, option) {
          return <span>{ option.storeName }</span>;
      },
    }
  },
  created() {
  },
  methods: {
    // 对话框关闭钩子
    onClose() {
      this.resetForm('ruleForm')
      this.leftDefaultChecked = []
      this.$emit('update:show',false)
    },
    // 门店change事件
    handleChange(value) {
      // const item = this.StoreConfigList.find(item => {
      //   return item.id === value
      // })
      // if(item) {
      //   this.ruleForm.storeName = item.storeName
      // }
    },
    // 配置门店
    handleConfiguration(row) {
      const {doctorId, doctorName, healthManagerType} = row
      this.ruleForm.healthManagerId = doctorId
      this.ruleForm.healthManagerName = doctorName
      this.ruleForm.healthManagerType = healthManagerType
      const data = {
        healthManagerId: row.doctorId,
        healthManagerType: row.healthManagerType
      }
      this.$nextTick(()=> {
        this.$refs.ruleForm.clearValidate(['storeIds']);
      })
      this.handleHealthManagerStoreConfigList(data)
    },
    // 获取配置门店列表
    handleHealthManagerStoreConfigList(data) {
      healthManagerStoreConfigList(data).then(res => {
        this.StoreConfigList = res.data
        // 
        this.leftDefaultChecked = res.data.filter(item => {
          return item.isChoose
        }).map(item => {
          return item.id
        })  
        this.ruleForm.storeIds = this.leftDefaultChecked
      })
    },
    submitForm() {
      const formName = 'ruleForm'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          healthManagerStoreBatchSave(this.ruleForm).then(res => {
            this.$message.success('配置门店成功')
            this.onClose()
            this.$emit('success')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm2(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>

<style lang="less" scoped>
.btn_flex {
    display: flex;
    justify-content: space-around
}

</style>